import { navLinks } from '@/mocks/guide';

const topicLinks = [
  { label: '投稿格式清单', href: '#format' },
  { label: '四步投稿流程', href: '#process' },
  { label: '退稿原因说明', href: '#notes' },
  { label: '匿名投稿通道', href: '#submit' },
];

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-950 text-background-100">
      <div className="w-full px-4 md:px-8 pt-14 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10 pb-10 border-b border-secondary-800">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-alarm-warning-line text-lg" aria-hidden="true" />
              </span>
              <span className="font-heading font-bold text-lg text-background-50">爆料51</span>
            </div>
            <p className="text-sm leading-relaxed text-background-300">
              一个面向公众的信息投稿平台。我们相信，把线索讲清楚，比把情绪放大更重要。
            </p>
            <p className="mt-4 text-sm text-background-300">
              投稿邮箱：<br />
              <span className="text-background-100">tip@baoliao51.example.com</span>
            </p>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50 mb-4">指南导航</h3>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-sm text-background-300 hover:text-primary-300 cursor-pointer transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50 mb-4">投稿相关</h3>
            <ul className="space-y-3">
              {topicLinks.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-sm text-background-300 hover:text-primary-300 cursor-pointer transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base text-background-50 mb-4">安全提示</h3>
            <p className="text-sm text-background-300 leading-relaxed">
              本平台所有投稿渠道均不收费，也不存在「付费加急」。凡以加急、删稿为名索要钱财者，均与爆料51 无关。
            </p>
            <a
              href="#submit"
              className="mt-4 inline-flex items-center gap-1.5 text-sm text-primary-300 hover:text-primary-200 cursor-pointer"
            >
              前往投稿入口
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </a>
          </div>
        </div>

        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <p>© {year} 爆料51 投稿指南. 本站内容用于说明投稿规范，不构成任何法律意见。</p>
          <p className="flex items-center gap-4">
            <a href="#top" className="hover:text-background-100 cursor-pointer transition-colors">回到顶部</a>
            <a href="#faq" className="hover:text-background-100 cursor-pointer transition-colors">常见问题</a>
          </p>
        </div>
      </div>
    </footer>
  );
}